/**
 * ConfidenceBar — reusable AI extraction confidence indicator.
 *
 * Variants:
 *   "full"    – label + percentage + thick bar (panels / drawers)
 *   "compact" – thin bar + percentage text (inline in rows / headers)
 *
 * Color thresholds: green >= 0.8, yellow >= 0.5, red < 0.5
 */

function ConfidenceBar({ value, variant = 'full', className = '' }) {
  if (value == null) return null;

  const pct = Math.round(value * 100);

  const barColor =
    value >= 0.8 ? 'bg-green-500' :
    value >= 0.5 ? 'bg-yellow-500' :
    'bg-red-500';

  const textColor =
    value >= 0.8 ? 'text-green-700' :
    value >= 0.5 ? 'text-yellow-700' :
    'text-red-700';

  if (variant === 'compact') {
    return (
      <div className={`flex items-center gap-1.5 ${className}`}>
        <span className="text-xs text-gray-500">Confidence</span>
        <div className="w-16 bg-gray-200 rounded-full h-1.5">
          <div
            className={`h-1.5 rounded-full ${barColor}`}
            style={{ width: `${pct}%` }}
          />
        </div>
        <span className={`text-xs font-medium ${textColor}`}>{pct}%</span>
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="flex justify-between items-center mb-1.5">
        <span className="text-sm text-gray-500">Confidence</span>
        <span className={`text-sm font-semibold ${textColor}`}>{pct}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`h-2 rounded-full transition-all duration-500 ${barColor}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}

export default ConfidenceBar;
